// The page's IndexedDB: one database, one object store per kind of thing.
//   jobs      finished and running print jobs of the USB device (jobstore.js)
//   printers  paired print server printers and their keys (keystore.js)
// Browsers do not sync IndexedDB between devices.
const DB_NAME = 'printy';
const VERSION = 2;

export function openDb(idb = globalThis.indexedDB) {
  return new Promise((resolve, reject) => {
    const req = idb.open(DB_NAME, VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      for (const name of ['jobs', 'printers']) {
        if (!db.objectStoreNames.contains(name)) db.createObjectStore(name, { keyPath: 'id' });
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

// Runs fn(objectStore) in a transaction on one store; resolves with the request's result.
export async function run(opened, store, mode, fn) {
  const db = await opened;
  return new Promise((resolve, reject) => {
    const tx = db.transaction(store, mode);
    const result = fn(tx.objectStore(store));
    tx.oncomplete = () => resolve(result?.result ?? result);
    tx.onerror = () => reject(tx.error);
    tx.onabort = () => reject(tx.error);
  });
}
